import { Subject } from 'rxjs';

import type { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';

export type MfaRetryRequest = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: AxiosRequestConfig<any>;
  resolve: (value: AxiosResponse) => void;
  reject: (error?: AxiosError | Error) => void;
  url: string;
  method: string;
  isNative: boolean;
};

/**
 * Subject that emits when MFA is required
 * Emits the full request context so the subscriber can queue it
 */
export const mfaRequiredSubject = new Subject<MfaRetryRequest>();
